import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(<App />);

// Firebase Cloud Messaging disabled - using WebSocket for real-time updates instead
// Uncomment below if you need background push notifications
/*
if (
  'serviceWorker' in navigator &&
  'Notification' in window &&
  window.isSecureContext
) {
  import('./lib/fcm')
    .then(m => m.initFcm())
    .catch((err) => {
      console.debug('FCM initialization skipped:', err);
    });
}
*/
